import React from "react";
import { NumericFormat } from "react-number-format";

const InputNumbersSimple = ({
  placeholder,
  onChange,
  id,
  name,
  value,
  error,
  readOnly = false,
  variant = "light",
}) => {
  return (
    <>
      <div>
        <NumericFormat
          className={`border-[1px] text-center rounded-[0.3rem] transition-all border-[#eeeeee]
        ease-in-out duration-100 placeholder-text-seondary-color drop-shadow-none
         text-text-primary-color focus:border-[#aaaaaa] outline-0 focus:outline-0 focus:ring-0
         font-lato text-[1rem] w-full  ${
           variant === "light" ? "font-normal" : "font-bold "
         } leading-normal  py-[1rem] px-[1.4rem]`}
          placeholder={placeholder}
          value={value}
          name={name}
          id={id}
          // readOnly={true}
          readOnly={readOnly}
          onChange={onChange}
          allowLeadingZeros
        />

        <div className="h-2">
          <label
            htmlFor={id}
            className="font-normal text-[0.75rem] text-red-500  bg-white  my-0 py-0 font"
          >
            {error}
          </label>
        </div>
      </div>
    </>
  );
};

export default InputNumbersSimple;
